'use client';

import Icon from '@/components/ui/AppIcon';

interface ContactMethod {
  icon: string;
  title: string;
  description: string;
  action: string;
  actionLink: string;
}

export default function ContactMethodsSection() {
  const contactMethods: ContactMethod[] = [
    {
      icon: 'PhoneIcon',
      title: 'Phone',
      description: 'Reservations & General Inquiries',
      action: '+91 72593 12233',
      actionLink: 'tel:+917259312233',
    },
    {
      icon: 'BuildingOfficeIcon',
      title: 'Corporate Accounts',
      description: 'Partnership & Bulk Bookings',
      action: '+91 63669 97020',
      actionLink: 'tel:+916366997020',
    },
    {
      icon: 'ChatBubbleLeftRightIcon',
      title: 'WhatsApp',
      description: 'Instant Messaging Support',
      action: '+91 72593 12233',
      actionLink: 'https://wa.me/917259312233',
    },
    {
      icon: 'EnvelopeIcon',
      title: 'Email',
      description: 'General Inquiries',
      action: 'enquiry@proximusindia.com',
      actionLink: 'mailto:enquiry@proximusindia.com',
    },
    {
      icon: 'CalendarIcon',
      title: 'Reservations',
      description: 'Booking & Availability',
      action: 'reservations@proximusindia.com',
      actionLink: 'mailto:reservations@proximusindia.com',
    },
    {
      icon: 'UserGroupIcon',
      title: 'Guest Services',
      description: 'Current Guest Support',
      action: 'guestservices@proximusindia.com',
      actionLink: 'mailto:guestservices@proximusindia.com',
    },
  ];

  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 text-accent mb-4">
            <Icon name="PhoneIcon" size={24} />
            <span className="text-sm font-semibold uppercase tracking-wide">Contact Methods</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary mb-4">
            Multiple Ways to Reach Us
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto">
            Choose your preferred method of communication. We're available through phone, email, WhatsApp, and social media.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contactMethods.map((method, index) => (
            <a
              key={index}
              href={method.actionLink}
              className="bg-white rounded-xl p-6 shadow-subtle hover:shadow-elevated transition-all duration-300 border border-border group"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-accent/10 transition-colors duration-300">
                  <Icon name={method.icon} size={24} className="text-accent" />
                </div>
                <div className="flex-1">
                  <h4 className="font-display text-lg font-semibold text-text-primary mb-1">{method.title}</h4>
                  <p className="text-sm text-text-secondary mb-2">{method.description}</p>
                  <p className="text-accent font-semibold text-sm group-hover:underline">{method.action}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-6 bg-white rounded-lg p-6 shadow-subtle">
            <span className="text-text-secondary font-medium">Follow us on social media:</span>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-primary/10 hover:bg-primary/20 rounded-full flex items-center justify-center transition-colors duration-300">
                <Icon name="GlobeAltIcon" size={20} className="text-primary" />
              </a>
              <a href="#" className="w-10 h-10 bg-primary/10 hover:bg-primary/20 rounded-full flex items-center justify-center transition-colors duration-300">
                <Icon name="EnvelopeIcon" size={20} className="text-primary" />
              </a>
              <a href="#" className="w-10 h-10 bg-primary/10 hover:bg-primary/20 rounded-full flex items-center justify-center transition-colors duration-300">
                <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-primary" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}